var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"premiumBtns"},[_vm._l((_vm.selectData.elementItems),function(btn,i){return [_c('span',{class:[
          'btns',
          'btn-l-' + _vm.selectData.elementItems.length,
          btn.color ? 'btn-c-' + btn.color : '',
          btn.disable && btn.disable == 'true' ? 'disable' : '' ],on:{"click":function($event){return _vm.btnClick(i)}}},[_vm._v(_vm._s(btn.name))])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }